<template>
  <TopBarComponent
    :left-image="{
      assetInfo: { name: 'as3', type: 'logo', extension: 'png' },
      alt: 'AS3 logo'
    }"
  />
  <div class="flex h-full w-full justify-items-center">
    <div class="mx-auto my-auto h-auto w-[512px] rounded-md bg-white px-6 py-6 shadow-xl">
      <div v-if="unsubscribeDone === false">
        <div class="border-b border-gray-200 pb-4">
          <HeaderComponent
            :heading="3"
            :title="$t('Unsubscribe_JobMatch_Header')"
            :text="urlEmail"
          />
        </div>
        <div class="pt-4">
          <HeaderComponent
            :heading="5"
            :title="$t('Unsubscribe_JobMatch_Sub_Header')"
            :text="$t('Unsubscribe_JobMatch_Sub_Text')"
          />
          <div class="mt-4 rounded-lg bg-zinc-50 px-4 py-4">
            <ul class="list-inside list-disc text-sm leading-5 text-slate-900 dark:text-slate-200">
              <li>{{ $t('Unsubscribe_JobMatch_List_One') }}</li>
              <li>
                {{ $t('Unsubscribe_JobMatch_List_Two') }}
              </li>
            </ul>
          </div>
          <div class="mt-6 flex justify-end space-x-4 sm:flex-row sm:items-stretch">
            <ButtonComponent
              :text="$t('General_Cancel')"
              type="outline"
              size="lg"
              @clicked="returnToHomePage"
            />
            <ButtonComponent
              :text="$t('General_Unsubscribe')"
              size="lg"
              :is-loading="loading"
              @clicked="unsubscribeStore.unsubscribe(route.query.candidateId as string)"
            />
          </div>
        </div>
      </div>
      <div v-else>
        <HeaderComponent
          :heading="3"
          :title="$t('Unsubscribe_JobMatch_Header')"
          :text="
            showErrorMessage
              ? $t('Unsubscribe_Error')
              : $t('Unsubscribe_JobMatch_No_Notifications_Text')
          "
        />
        <div class="mt-4 flex justify-end space-x-4">
          <ButtonComponent
            :text="$t('Unsubscribe_Go_To_Portal')"
            size="lg"
            @clicked="returnToHomePage"
          />
        </div>
      </div>
    </div>
  </div>
</template>
<script setup lang="ts">
import { useUnsubscribeStore, useLocalizationStore } from '@/stores'
import { storeToRefs } from 'pinia'

// Props and Emits

// Constants and Refs
const unsubscribeStore = useUnsubscribeStore()
const { unsubscribeDone, showErrorMessage, loading } = storeToRefs(unsubscribeStore)
const localizationStore = useLocalizationStore()
const route = useRoute()

// Lifecycle Hooks

// Methods/Functions
const urlEmail = computed(() => {
  const email = route.query.email
  return localizationStore.translate('unsubscribe_JobMatch_Text', {
    email: '<strong>' + email + '</strong>'
  })
})

const returnToHomePage = () => {
  location.href = location.origin
}
</script>
